<script>
import { find, sum, map } from "lodash";
export default {
  props: {
    value: { type: Array, required: true },
    params: { type: Array, required: true },
  },
  data() {
    return {
      bases: this.value,
    };
  },
  methods: {
    addBase() {
      this.bases.push({
        base: null,
        adultos: 0,
        menores: 0,
        edades: [],
        extra: null,
      });
    },
    removeBase(key) {
      this.bases = this.bases.filter((item, index) => {
        return index !== key;
      });
    },
  },
  watch: {
    bases: {
      deep: true,
      handler() {
        if (this.bases.length) {
          this.bases.forEach((base, key) => {
            const hab = find(this.params, ["id", base.base]);
            if (base.extra != hab) {
              this.bases[key]["menores"] = 0;
              this.bases[key]["edades"] = [];
              if (hab) {
                this.bases[key]["extra"] = hab;
                this.bases[key]["adultos"] = hab.adultos;
                for (let i = 0; i < hab.adultos; i++) {
                  this.bases[key]["edades"].push(0);
                }
              } else {
                this.bases[key]["extra"] = null;
                this.bases[key]["adultos"] = 0;
              }
            }

            if (
              this.bases[key]["adultos"] + this.bases[key]["menores"] !==
              this.bases[key]["edades"].length
            ) {
              const edades = [];

              for (let i = 0; i < hab.adultos; i++) {
                edades.push(this.bases[key]["edades"][i]);
              }

              for (let i = 0; i < this.bases[key]["menores"]; i++) {
                edades.push(0);
              }

              this.bases[key]["edades"] = edades;
            }
          });
        }

        this.$emit("input", this.bases);
      },
    },
  },
};
</script>

<template>
  <div class="list-group-item" id="habitaciones">
    <table class="table">
      <tbody>
        <template v-for="(base, key) in bases">
          <tr class="warning" :key="key">
            <th v-html="`Habitaci&oacute;n ${key + 1}`"></th>
            <td>
              <div class="input-group">
                <select
                  :id="`base_${key}`"
                  class="form-control input-sm"
                  v-model="bases[key]['base']"
                >
                  <option :value="null">Seleccionar</option>
                  <option
                    v-for="param in params"
                    :key="`${key}_${param.id}`"
                    :value="param.id"
                    v-html="param.nombre"
                  ></option>
                </select>
                <div class="input-group-btn">
                  <btn type="danger" size="sm" @click="removeBase(key)">X</btn>
                </div>
              </div>
            </td>
          </tr>

          <template v-if="base.base">
            <tr :key="`adultos_${key}`">
              <th><i class="fa fa-male"></i> Adultos</th>
              <td v-text="base.adultos"></td>
            </tr>

            <template v-for="adulto in base.adultos">
              <tr :key="`edad_${key}_${adulto}`">
                <th>
                  <i class="fa fa-calendar"></i>
                  <span v-text="`Adulto ${adulto}`"></span>
                </th>
                <td>
                  <select
                    class="form-control"
                    :id="`adultos_${key}`"
                    v-model.number="bases[key]['edades'][adulto - 1]"
                  >
                    <option :value="0">Seleccionar</option>
                    <optgroup
                      v-for="edad in base.extra.adultosEdades"
                      :key="`${adulto}-adulto-${edad.id}`"
                      :label="edad.nombre"
                    >
                      <option
                        v-for="i in edad.edades"
                        :key="i"
                        :value="i"
                        v-html="`${i} A&ntilde;os`"
                      ></option>
                    </optgroup>
                  </select>
                </td>
              </tr>
            </template>

            <tr :key="`menores_${key}`">
              <th><i class="fa fa-child"></i> Menores</th>
              <td>
                <input
                  type="number"
                  class="form-control"
                  :min="base.extra.menoresRangos.min"
                  :max="base.extra.menoresRangos.max"
                  v-model.number="bases[key]['menores']"
                />
              </td>
            </tr>

            <template v-for="menor in base.menores">
              <tr :key="`edad_${key}_${base.adultos + menor}`">
                <th>
                  <i class="fa fa-calendar"></i>
                  <span v-text="`Menor ${menor}`"></span>
                </th>
                <td>
                  <select
                    class="form-control"
                    :id="`menor_${key}_${menor}`"
                    v-model.number="
                      bases[key]['edades'][base.adultos + menor - 1]
                    "
                  >
                    <option :value="0">Seleccionar</option>
                    <optgroup
                      v-for="edad in base.extra.menoresEdades"
                      :key="`menor_${key}_${menor}_${edad.id}`"
                      :label="edad.nombre"
                    >
                      <option
                        v-for="i in edad.edades"
                        :key="i"
                        :value="i"
                        v-html="`${i} A&ntilde;os`"
                      ></option>
                    </optgroup>
                  </select>
                </td>
              </tr>
            </template>
          </template>
        </template>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="2">
            <btn
              type="info"
              block
              size="sm"
              @click="addBase"
              v-html="'Agregar Habitaci&oacute;n'"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" >
#habitaciones {
  padding: 0;

  .table {
    margin: -1px 0 0;
    > tbody {
      > tr {
        > th,
        > td {
          height: 41px;
          padding: 5px 10px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>